import { messages } from "../i18n/messages.js";

export function LoadingState({ label = messages.session.connecting }: { label?: string }) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3 p-6">
      <div
        className="h-10 w-10 animate-spin rounded-full border-2 border-current border-t-transparent opacity-60"
        role="status"
        aria-label={label}
      />
      <p className="text-sm opacity-70">{label}</p>
    </div>
  );
}
